import { render, staticRenderFns } from "./bulkImport.vue?vue&type=template&id=b4980c80&scoped=true"
import script from "./bulkImport.vue?vue&type=script&lang=js"
export * from "./bulkImport.vue?vue&type=script&lang=js"
import style0 from "./bulkImport.vue?vue&type=style&index=0&id=b4980c80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4980c80",
  null
  
)

export default component.exports